import { DeepPartial, DynamicConfig } from '@empathybroker/ebx-gluon';

export const DYNAMIC_CONFIG: DeepPartial<DynamicConfig> = {
  endpoints: {
    search: 'api{env}.empathybroker.com/search/v1/query/tuandco/searchX',
    suggestions: 'api{env}.empathybroker.com/search/v1/query/tuandco/empathize',
    clicksRecommendations: 'api{env}.empathybroker.com/search/v1/query/tuandco/topclicked',
    queriesRecommendations: 'api{env}.empathybroker.com/search/v1/query/tuandco/topclicked',
    sectionRecommendations: 'api{env}.empathybroker.com/search/v1/query/tuandco/topclicked',
    topRecommendations: 'api{env}.empathybroker.com/search/v1/query/tuandco/topclicked',
    userRecommendations: 'api{env}.empathybroker.com/search/v1/query/tuandco/topclicked'
  }
};
